import React from 'react';
import PropTypes from 'prop-types';
import HeadingWrapper from './PageHeading.css';

const PageHeading = ({ text }) => <HeadingWrapper data-cy="page-title">{text}</HeadingWrapper>;

PageHeading.propTypes = { text: PropTypes.string.isRequired };

export default PageHeading;
